import { Theme } from '@desygner/ui-common-components';

export const { Size } = Theme.Icon;
